"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const faqs = [{
    id: "faq-1",
    question: "What types of motorcycle repairs does MotoRevive specialize in?",
    answer: "MotoRevive specializes in motorcycle panel respray, crash repair, frame restoration, dent removal, paint touch-ups, custom graphics & decals, OEM-grade paint matching, precision welding, and full project consultation for riders, clubs, and dealers."
  }, {
    id: "faq-2",
    question: "How long does a typical panel respray or crash repair take?",
    answer: "Turnaround times vary depending on the extent of damage and project scope. Most standard panel resprays and minor repairs are completed within 3-5 business days. Major crash repairs or full frame restorations may take 1-2 weeks. We provide a detailed timeline during your consultation."
  }, {
    id: "faq-3",
    question: "Do you offer custom graphics and unique finishes?",
    answer: "Yes! MotoRevive offers custom graphics design and application, including unique decals, racing stripes, and personalized artwork. Our team works with you to create a one-of-a-kind look that reflects your style and personality."
  }, {
    id: "faq-4",
    question: "Is there a warranty on your paint work and repairs?",
    answer: "Absolutely. We stand behind our craftsmanship with a lifetime warranty on all paint work. This ensures that your motorcycle's finish remains vibrant and durable for years to come."
  }, {
    id: "faq-5",
    question: "Can I see examples of your previous work?",
    answer: "Yes, we showcase a comprehensive portfolio of before-and-after photos on our website. You can view our completed projects to see the quality and precision of our restoration work."
  }, {
    id: "faq-6",
    question: "How do I schedule an appointment or consultation?",
    answer: "You can schedule an appointment using our online appointment scheduler available on the website, or contact us directly at (555) 987-6543 or contact@motorevive.com. We're here Mon-Fri: 8am - 6pm, Sat: 9am - 3pm."
  }, {
    id: "faq-7",
    question: "Do you work with insurance companies for crash repairs?",
    answer: "Yes, we work with most insurance providers and can assist with the claims process. We provide comprehensive damage assessments and detailed repair estimates to help streamline your insurance claim."
  }, {
    id: "faq-8",
    question: "What brands of paint do you use for resprays?",
    answer: "We use only OEM-grade paints to ensure perfect color matching and long-lasting durability. Our paint selection process includes detailed color analysis to match your motorcycle's original finish or desired custom color."
  }];
  return <section ref={ref} className="bg-dark-background text-foreground-dark py-16 px-4 sm:px-6 lg:px-8">
      
    </section>;
}